// extracted by mini-css-extract-plugin
export var animationContainer = "_n5-0";
export var footer = "_n5-1";
export var gray = "_n5-2";
export var lineItem = "_n5-3";
export var lineItemImage = "_n5-4";
export var lineItemInfo = "_n5-5";
export var lineItemText = "_n5-6";
export var lineItems = "_n5-7";
export var modalContent = "_n5-8";
export var options = "_n5-9";
export var orderName = "_n5-a";
export var refundAmount = "_n5-b";